// @flow

import React, { Suspense } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Grid, Link } from '@material-ui/core/';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import AppTable from '../../../components/table';
import Code from '../../../components/block/code';
import DocsIntroduction from '../../../data/cms/content/docs-introduction';
//import Statecollapsible from '../../../components/collapsible/statecitycodes';
import { Element, scroller } from 'react-scroll';

import './style.css';
type Props = {
    scroll: String,
};
function Introduction(props: Props) {
    const { scroll } = props;
    const OtherComponent = React.lazy(() =>
        import('../../../components/collapsible/statecitycodes')
    );
    const scrollTo = () => {
        scroller.scrollTo('scroll-to-element', {
            duration: 500,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -140,
        });
    };
    const [GetDocsInto, setDocsIntoContent] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    React.useEffect(() => {
        const fetchContent = async () => {
            var fetchedContent = await DocsIntroduction();
            setDocsIntoContent(fetchedContent);
            setLoading(false);
            window.scrollTo(0, 0);
            if (scroll === 'yes') {
                scrollTo();
            }
        };
        fetchContent();
    }, [scroll]);

    return (
        <Grid container className="doc-body">
            <Grid item sm={12} md={12} lg={12}>
                <Grid className="docs-intro-breadcumb">
                    <Breadcrumbs
                        separator={<NavigateNextIcon fontSize="small" />}
                        aria-label="breadcrumb"
                    >
                        <Link
                            component={RouterLink}
                            to={{
                                pathname: '/',
                                search: null,
                            }}
                        >
                            home
                        </Link>
                        <Link href="/docs">Documents</Link>

                        <Typography color="textPrimary">
                            introduction
                        </Typography>
                    </Breadcrumbs>
                </Grid>
                {!loading ? (
                    <>
                        <Typography component="h3">
                            {GetDocsInto.Docs.Introduction.Info.Title}
                        </Typography>
                        <Typography
                            component="p"
                            dangerouslySetInnerHTML={{
                                __html:
                                    GetDocsInto.Docs.Introduction.Info.Content,
                            }}
                        ></Typography>
                        <Typography component="h3">
                            {GetDocsInto.Docs.Introduction.Authentication.Title}
                        </Typography>
                        <Typography
                            component="p"
                            dangerouslySetInnerHTML={{
                                __html:
                                    GetDocsInto.Docs.Introduction.Authentication
                                        .Content,
                            }}
                        ></Typography>
                        <Typography component="p">
                            {GetDocsInto.Docs.Introduction.Authentication.Line1}
                        </Typography>
                        <Typography
                            component="p"
                            dangerouslySetInnerHTML={{
                                __html:
                                    GetDocsInto.Docs.Introduction.Methods.Method
                                        .Post.Title,
                            }}
                        ></Typography>

                        <Typography component="h3">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .Supported.Title
                            }
                        </Typography>
                        <Typography component="p">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .Supported.Content
                            }
                        </Typography>
                        <AppTable>
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .Supported.SupportParameters.Parameter
                                    .Parameters
                            }
                        </AppTable>

                        <Typography component="h3">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .Errors.Title
                            }
                        </Typography>
                        <Typography component="p">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .Errors.Content
                            }
                        </Typography>
                        <Typography component="h3">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.Title
                            }
                        </Typography>
                        <AppTable>
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.ResponseAttributes
                                    .Attributes
                            }
                        </AppTable>
                        <Typography component="h3">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.Version.Title
                            }
                        </Typography>
                        <Typography component="p">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.Version.Content
                            }
                        </Typography>
                        <Typography
                            component="p"
                            dangerouslySetInnerHTML={{
                                __html:
                                    GetDocsInto.Docs.Introduction.Methods.Method
                                        .HTTPstatusCode.Version.Line1,
                            }}
                        ></Typography>
                        <Typography component="p">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.Version.CurrentVersion
                                    .Content
                            }
                        </Typography>
                        <AppTable>
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.Version.CurrentVersion
                                    .Method.Methods
                            }
                        </AppTable>

                        <Typography component="h4">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.Example.Title
                            }
                        </Typography>
                        <Code>
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.Example.URL
                            }
                        </Code>
                        <Element name="scroll-to-element">
                            <Typography component="h3">
                                {
                                    GetDocsInto.Docs.Introduction.Methods.Method
                                        .StateCityCode.Title
                                }
                            </Typography>
                            <Suspense fallback={<Typography component="div">Loading...</Typography>}>
                                <OtherComponent
                                    data={
                                        GetDocsInto.Docs.Introduction.Methods
                                            .Method.StateCityCode.StateCityCodes
                                    }
                                />
                            </Suspense>
                        </Element>
                        <Typography component="h3">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.Pagination.Title
                            }
                        </Typography>
                        <Typography component="p">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.Pagination.Content
                            }
                        </Typography>
                        <Typography component="h3">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.RequestLimit.Title
                            }
                        </Typography>
                        <Typography component="p">
                            {
                                GetDocsInto.Docs.Introduction.Methods.Method
                                    .HTTPstatusCode.RequestLimit.Content
                            }
                        </Typography>

                        <Typography component="h3">
                            {GetDocsInto.Docs.Introduction.CommingSoon.Title}
                        </Typography>
                        <Typography
                            component="p"
                            dangerouslySetInnerHTML={{
                                __html:
                                    GetDocsInto.Docs.Introduction.CommingSoon
                                        .Content,
                            }}
                        ></Typography>
                    </>
                ) : (
                    ' '
                )}
            </Grid>
        </Grid>
    );
}

export default Introduction;
